import { LogoMark } from "@/components/Logo";
import { useLang } from "@/contexts/LanguageContext";

export default function Footer() {
  const { t } = useLang();
  const year = new Date().getFullYear();
  return (
    <footer className="bg-[#0A0A0A] text-[#EAE4D5] mt-32" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-5 md:px-8 py-20 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="flex items-center gap-3">
            <LogoMark size={36} />
            <span className="font-serif-display text-3xl">Aqion</span>
          </div>
          <p className="mt-5 text-[#B6B09F] text-sm max-w-md leading-relaxed">
            {t.about.desc}
          </p>
        </div>
        <div className="md:col-span-3">
          <div className="label-eyebrow text-[#B6B09F]">{t.nav.services}</div>
          <ul className="mt-4 space-y-2 text-[#EAE4D5] text-sm">
            {t.services.items.map((s) => <li key={s.key}>{s.title}</li>)}
          </ul>
        </div>
        <div className="md:col-span-2">
          <div className="label-eyebrow text-[#B6B09F]">{t.nav.contact}</div>
          <ul className="mt-4 space-y-2 text-[#EAE4D5] text-sm">
            <li>{t.contact.email_addr}</li>
            {t.contact.phone && <li>{t.contact.phone}</li>}
            <li>İstanbul, Türkiye</li>
          </ul>
        </div>
        <div className="md:col-span-2 flex md:justify-end items-end">
          <div className="font-mono-aq text-[0.65rem] tracking-[0.22em] uppercase text-[#B6B09F]">
            v.1.0 — {year}
          </div>
        </div>
      </div>
      <div className="border-t border-white/5">
        <div className="max-w-7xl mx-auto px-5 md:px-8 py-6 flex flex-col md:flex-row items-center justify-between text-xs text-[#B6B09F] font-mono-aq tracking-wider">
          <div>© {year} {t.footer.made}. {t.footer.rights}</div>
          <div className="mt-2 md:mt-0">AQ // {String(year).slice(-2)}</div>
        </div>
      </div>
    </footer>
  );
}
